import { type ExportTaskStatus } from '@webapp/modules/reports/entities/enums/ExportTaskStatusEnum'
import { type ReportExportTaskConstructor } from '@webapp/modules/reports/entities/ReportExportTask'
import { type ReportExportTaskApiModel } from '../api-models/ReportExportTaskApiModel'

export const mapReportExportTaskApiModel = (
  apiModel: ReportExportTaskApiModel
): ReportExportTaskConstructor => ({
  id: apiModel.id,
  uuid: apiModel.uuid,
  status: apiModel.status as ExportTaskStatus,
  filters: apiModel.filters.map((filter) => ({
    label: filter.label,
    value: filter.value,
    ...(filter.type === 'date' ? { type: 'date' as const } : {}),
  })),
  file: apiModel.file
    ? { uuid: apiModel.file.uuid, name: apiModel.file.name }
    : null,
  index: apiModel.index,
  max: apiModel.max,
  createdAt: apiModel.created_at,
  requestedDate: apiModel.requested_date,
  isActive: apiModel.is_active,
})
